export default __webpack_public_path__ + "assets/images/5f5f7d4d38abb3c50e7086e405abefcf.svg";